// File: src/components/social/NotificationItem/NotificationItem.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { Bell } from "lucide-react";

interface NotificationItemProps {
  message: string;
  timeAgo: string;
  read?: boolean;
  onClick?: () => void;
}

const Container = styled.div<{ read: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme, read }) =>
    read ? theme.colors.surface : theme.colors.primaryHover};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primarySelected};
  }
`;

const Icon = styled(Bell)`
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Message = styled.div`
  flex: 1;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
`;

const Time = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
`;

export const NotificationItem: React.FC<NotificationItemProps> = ({
  message,
  timeAgo,
  read = false,
  onClick,
}) => {
  return (
    <Container read={read} onClick={onClick}>
      <Icon size={20} />
      <Message>{message}</Message>
      <Time>{timeAgo}</Time>
    </Container>
  );
};